// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Trigger__trigger__root cmp-components__clickable__root"};